import React from "react";
import { connect } from "react-redux";
import history from "../../auth/history";

class PaymentStaticTxt extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
		
		}
    }

    componentDidMount(){}
	componentWillUnmount(){
    }


    

    render(){
    console.log('Inside render');
    return(
        <div class="notxt">
        <p>If the transaction was a success, your Corporate account would be credited instantly once (Only during Banking hours).</p>
        <p class="text-danger">Note - This won’t be applicable if your official bank account is Yes Bank.</p>
        </div>
		);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage,otpErrorMessage},
	 miscReduce:{otpRefNo,phone}}
	) => ({
		errorMessage,loginErrorMessage,otpErrorMessage,otpRefNo,phone
});

export default connect(mapStateToProps, null)(PaymentStaticTxt);
